<template>
    <div class="card">
        <div class="card-body" v-if="chartOptions">
            <p class="chart-title">{{ label }}</p>
            <apexcharts v-if="isReady" :key="chartKey" type="bar" :options="chartOptions" :series="series" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    components: { apexcharts: VueApexCharts },
    props: {
        chartData: { type: Object, required: true },
        label: { type: String, required: true },
        chartType: { type: Boolean, required: false, default: true },
        colors: {type: Array, required: false}

    },
    computed: {
        
        series() {
            return [{
                data: this.chartData.series || []
            }]
        },
        chartOptions() {
            return {
                chart: {
                    width: 620, type: 'bar',
                    toolbar: {
                        show: false
                    },
                },

                plotOptions: {
                    bar: {
                        borderRadius: 1,
                        borderRadiusApplication: 'end',
                        horizontal: this.chartType,
                        distributed: true
                    },

                },
                legend: { show: false },
                dataLabels: { enabled: true },
                xaxis: {
                    categories: this.chartData.labels || [],
                    labels: {
                        style: {
                             fontSize: '14px',
                             colors: '#000000'
                        }
                    }
                },
                colors: this.colors || []
            };
        },
        isReady() {
            return Array.isArray(this.chartData.series) &&
                this.chartData.series.length > 0 &&
                Array.isArray(this.chartData.labels) &&
                this.chartData.labels.length > 0;
        },
        chartKey() {
            // Isso força re-montagem real, se necessário:
            return JSON.stringify(this.series) + JSON.stringify(this.chartOptions.labels);
        }
    }
}
</script>
<style>
.apexcharts-canvas {
    margin: 0 auto !important;
}
</style>
